import Cookies from 'js-cookie';
import { getAuthHeaders } from '../../../utils/authHeaders';

export interface OffersTypes {
  active_from: string;
  active_to: string;
  created_by: number;
  id: number;
  offer_name: string;
  offer_type: string;
  /** Full (non-sale) price. */
  pay_amount: number;
  receive_amount: number;
  /** Price to pay right now; equals `pay_amount` unless a sale is active. */
  price?: number;
  base_price?: number;
  on_sale?: boolean;
  sale_percent?: number | null;
  sale_ends_at?: string | null;
  sale_label?: string | null;
}

export function currentPrice(offer: OffersTypes): number {
  return offer.price ?? offer.pay_amount;
}

/** Offer with the lowest full price per unit received, if it is uniquely the cheapest. */
export function bestValueOfferId(offers: OffersTypes[]): number | null {
  if (offers.length < 2) return null;
  const perUnit = offers
    .filter((o) => o.receive_amount > 0)
    .map((o) => ({ id: o.id, rate: o.pay_amount / o.receive_amount }))
    .sort((a, b) => a.rate - b.rate);
  if (perUnit.length < 2 || perUnit[0].rate === perUnit[1].rate) return null;
  return perUnit[0].id;
}

async function fetchOffers(offerType?: 'hard' | 'soft'): Promise<OffersTypes[]> {
  const session_token = Cookies.get('c8_session_token') || '';
  const qs = new URLSearchParams({
    ...(offerType && { offer_type: offerType }),
    user_session: session_token,
  });
  const res = await fetch(`${process.env.API_URL}/offers?${qs.toString()}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch ${offerType ?? 'all'} offers: ${res.status}`);
  }
  return res.json();
}

export async function getAllOffers(): Promise<OffersTypes[]> {
  return fetchOffers();
}

export async function getHardOffers(): Promise<OffersTypes[]> {
  return fetchOffers('hard');
}

export async function getSoftOffers(): Promise<OffersTypes[]> {
  return fetchOffers('soft');
}
